import { Editor } from '@tinymce/tinymce-react'
import { ErrorMessage } from 'formik'
import React, { useRef, useState } from 'react'
import { handleLabelNameChanges } from '../../automation'
import MediaManagerModal from '../MediaManagerModal'

type Props = {
  containerClassName?: string
  label?: any
  limit?: number
  name: string
  initialValue?: any
  rules?: any
  input?: any
  height?: number | undefined
  handleChange: any
  labelClassName?: any
  required?: boolean
  errors?: any
}

const FormTinyMce: React.FC<Props> = ({
  containerClassName,
  limit,
  labelClassName,
  label,
  name,
  initialValue,
  rules,
  input,
  height,
  handleChange,
  required,
  errors,
  ...rest
}) => {
  const editorRef: any = useRef(null)
  const [mediaManagerModalOpen, setMediaManagerModalOpen] = useState(false)
  const [editorCallBack, setEditorCallBack] = useState<any>()

  const handleCloseMediaManagerModal = () => {
    setMediaManagerModalOpen(false)
  }

  const callingFunction = (cb: any) => {
    const callBackFile = {
      callback: (downloadLink: string, title: string) => {
        cb(downloadLink, { title })
      },
    }
    setEditorCallBack(callBackFile)
  }

  return (
    <div
      className={label ? 'mb-6' : 'col-lg-6 '}
      data-cy={`${handleLabelNameChanges(name)}-tiny-editor`}
    >
      {label && (
        <label className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          {label}
          <span className={required ? 'required' : ''}></span>
        </label>
      )}
      <Editor
        apiKey='3qyej0twovgwvklxo176yhnorvfpy2f965i3ac4d56gm4fpr'
        ref={editorRef}
        data-cy={`${name}-editor-field`}
        // tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        onInit={(evt: any, editor: any) => (editorRef.current = editor)}
        initialValue={initialValue}
        onEditorChange={(e: any) => {
          handleChange({ target: { name, value: e } })
        }}
        init={{
          height: height ? height : 350,
          menubar: false,
          browser_spellcheck: false,
          placeholder: 'Write your content here...',
          automatic_uploads: true,
          file_picker_types: 'image',
          toolbar_mode: 'sliding',
          forced_root_block: 'p',
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'help',
            'directionality',
            'nonbreaking',
            'pagebreak',
            'emoticons',
            'link',
            'image',
            'wordcount',
            'charmap',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'insertdatetime',
            'media',
            'table',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'link image |' +
            'code |' +
            'insertdatetime |' +
            'table tabledelete |' +
            'emoticons |' +
            'bold italic forecolor | alignleft aligncenter |' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat',
          content_style: 'body { font-family:avenir-regular,Arial,sans-serif; font-size:14px }',

          file_picker_callback: function (cb: any, value: any, meta: any) {
            setMediaManagerModalOpen(true)
            callingFunction(cb)
          },
        }}
        textareaName={name}
        {...rest}
      />

      <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
        <ErrorMessage name={name} component='div' className='field-error-message' />
      </div>

      <MediaManagerModal
        isOpen={mediaManagerModalOpen}
        handleClose={handleCloseMediaManagerModal}
        editorCallBack={editorCallBack}
      />
    </div>
  )
}

export default FormTinyMce
